import gql from 'graphql-tag'

export default config => async payload => {
  const {
    client,
    table,
    defaultOutput,
    defaultFragments,
    fetchPolicy,
    primaryKey,
    alias = 'item'
  } = config

  const { output = defaultOutput, fragments = defaultFragments || '' } = payload

  let pk_columns = primaryKey.map(name => {
    if (!payload[name]) throw new Error(`${name} is undefined`)
    return `${name}: "${payload[name]}"`
  })

  const query = gql`
      query {
        ${alias}: ${table}_by_pk(${pk_columns.join(',')}) {
            ${output}
        }
      }
      ${fragments}
    `

  const { data } = await client.query({
    fetchPolicy,
    query
  })

  return data[alias]
}
